<div>
  <label class="field-label">
    {{ label }}
    @if (isRequired) {
    <span class="text-red-600" aria-hidden="true">*</span>
    }
  </label>
  <ng-select
    #selectElement2
    [formControl]="control"
    [items]="options"
    [searchable]="true"
    [searchFn]="customSearch"
    [bindLabel]="labelKey"
    [bindValue]="valueKey"
    [placeholder]="placeholder"
    [virtualScroll]="true"
    [loading]="loading"
    [editableSearchTerm]="false"
    [searchable]="!showMemberFilter"
    (search)="onType($event)"
    (clear)="onCleared()"
    (close)="onDropdownClosed()"
    (change)="onOptionSelected($event)"
    class="w-full"
  >
    <!-- Header Template -->
    @if(showMemberFilter){
    <ng-template ng-header-tmp>
      <!-- <div class="p-2">
      <label class="block text-sm font-semibold text-dc-navy">{{"SEARCH_BY" | translate}}</label>
      <div class="flex gap-4 text-sm">
        @for (filterBy of searchByOptions; track filterBy['value'] ?? $index) {
        <label class="flex items-center gap-x-2 py-2">
          <input
            type="radio"
            name="searchBy"
            [value]="filterBy.value"
            [(ngModel)]="searchBy"
            (change)="onSearchByChange()"
            class="form-radio h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy"
          />
          <span class="text-sm text-dc-navy">{{ filterBy.label | translate}}</span>
        </label>
        }
      </div>
      	<input class="w-full px-3 py-2 text-dc-navy border-dc-navy border focus:outline-none disabled:cursor-not-allowed"
          type="text" [placeholder]="'SEARCH_HERE' | translate" (input)="searchMember($event)" />
    </div> -->
      <div class="p-2">
        <label class="block text-sm font-semibold text-dc-navy">
          {{ "SEARCH_BY" | translate }}
        </label>

        <!-- Radio Buttons -->
        <div class="flex gap-4 text-sm">
          @for (filterBy of searchByOptions; track $index) {
          <label class="flex items-center gap-x-2 py-2">
            <input
              type="radio"
              name="searchBy"
              [value]="filterBy.value"
              [(ngModel)]="searchBy"
              (change)="onSearchByChange()"
              class="form-radio h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy"
            />
            <span class="text-sm text-dc-navy">
              {{ filterBy.label | translate }}
            </span>
          </label>
          }
        </div>

        <!-- Search Input + Buttons -->
        <div class="flex items-center gap-3 mt-2">
          <input
            class="w-full px-3 py-2 text-dc-navy border border-dc-navy focus:outline-none disabled:cursor-not-allowed"
            type="text"
            [(ngModel)]="searchText"
            [placeholder]="'SEARCH_HERE' | translate"
          />

          <!-- Search Button -->
          <app-button
            [label]="'BUTTONS.SEARCH' | translate"
            [classesName]="''"
            (onBtnClick)="onSearchClick()"
            [disabled]="loading"
          ></app-button>
          <!-- <button
            class="px-4 py-2 bg-dc-navy text-white text-sm rounded hover:bg-dc-dark-blue"
            (click)="onSearchClick()"
          >
            {{ 'BUTTONS.SEARCH' | translate }}
          </button> -->

          <!-- Clear Button -->
          <app-button
            [label]="'BUTTONS.CLEAR' | translate"
            [classesName]="'card-edge-cut-white'"
            (onBtnClick)="onClearClick()"
          ></app-button>
        </div>
      </div>
    </ng-template>

    }

    <!-- each row ------>
    <ng-template
      ng-option-tmp
      let-item="item"
      let-index="index"
      (click)="$event.stopPropagation()"
    >
      <div
        class="flex items-start justify-between gap-4"
        (click)="$event.stopPropagation()"
      >
        <!-- membersip activities -->
        @if (lovType == 'XX_CODE_ACTIVITIES') {
        <div class="max-w-full">
          @if (item.code) {
          <p class="text-xs text-dc-navy!">
            {{ item.code }}
          </p>
          }
          <p class="text-dc-navy! font-semibold">
            {{ item.name }}
          </p>
          @if (item.description) {
          <p class="font-xs text-dc-navy!">
            {{ item.description }}
          </p>
          } @if (otherActionText) {
          <a class="text-dc-navy text-xs mt-5 underline">{{
            otherActionText
          }}</a>
          }
        </div>
        }

        <!-- code & name -->
        @if (!lovType) {
        <div class="max-w-full">
          @if (item.code) {
          <p class="text-xs text-dc-navy!">
            {{ item.code }}
          </p>
          }
          <p class="text-dc-navy! font-semibold">
            {{ item.name }}
          </p>
          @if (item?.description) {
          <p class="font-xs text-dc-navy!">
            {{ item.description }}
          </p>
          } @if (otherActionText) {
          <a class="text-dc-navy text-xs mt-5 underline">{{
            otherActionText
          }}</a>
          } @if(item['memberNumber'] || item['licenseNumber']){
          <span class="w-full grid grid-cols-1 text-sm font-light text-dc-navy">
            <span>
              {{ "SEARCH_BY_MEM_NUMBER" | translate }}:
              {{ item["memberNumber"] }}</span
            >
            <span
              >{{ "SEARCH_BY_MEM_LICENSE" | translate }}:
              {{ item["licenseNumber"] }}</span
            >
          </span>
          }
        </div>
        }

        <!-- Add button -->
        @if(showAction){
        <button
          type="button"
          class="underline text-dc-navy text-sm font-semibold shrink-0 self-end"
          (click)="addItem(item); $event.stopPropagation()"
        >
          {{ "ADD_ACTIVITY" | translate }}
        </button>
        }
      </div>
    </ng-template>

    <!-- what shows when closed ---------->
    <ng-template ng-label-tmp let-item="item">
      {{ item.name }}
    </ng-template>

    <!-- loader inside dropdown -->
    <ng-template ng-loading-text>
      <div class="flex items-center gap-2">
        <i class="fa fa-spinner fa-spin text-gray-500"></i>
        <span>{{ "LOADING" | translate }}</span>
      </div>
    </ng-template>

    <!-- No record found -->
    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      @if (!allowAddNew) {
        @if(showMemberFilter){
          @if(isCalledToSearch && searchText && options.length < 1 && !loading){
            <div class="ng-option disabled text-dc-navy!">
              {{ "NOT_DATA_FOUND" | translate }}"{{ searchTerm }}{{ searchText }}"
            </div>
          }
        }@else{
          <div class="ng-option disabled text-dc-navy!">
            {{ "NOT_DATA_FOUND" | translate }}"{{ searchTerm }}{{ searchText }}"
          </div>
        }
      } @if (allowAddNew) {
      <div class="ng-option text-dc-navy!">
        {{ notFoundText }}
        @if(showAction){
        <span class="cursor-pointer underline font-bold" (click)="openAddForm()"
          >{{ "CLICK_TO_ADD" | translate }}
        </span>
        }
      </div>
      }
    </ng-template>

    <ng-template ng-footer-tmp>
      @if(showPageNation){
      <div
        class="px-3"
        (click)="$event.stopPropagation()"
        (mousedown)="$event.stopPropagation()"
      >
        <app-pagenation
          [data]="{
            currentPage: optionCurrentPage,
            totalPages: totalOptionPages,
            totalItems: noOfTotalRecords
          }"
          (pageChangeEvent)="loadPage($event)"
        ></app-pagenation>
      </div>
      }
    </ng-template>
  </ng-select>

  <div class="fields-error-container">
    @if (control.touched && control.invalid) { @for (errorKey of errorKeys;
    track errorKey ?? $index) { @if (control.hasError(errorKey)) {
    {{
      validationMessages[errorKey] ||
        (errorKey === "required"
          ? ("VALIDATION_MSG.FIELD_REQUIRED" | translate)
          : "Invalid value")
    }}
    <br />
    } } }
  </div>
</div>

<!-- Show selected items -->
@if (selectedItems && selectedItems.length > 0 && showSelectedItemsList) {
<div class="border border-dc-navy text-sm mb-5">
  <div
    class="flex items-center justify-between px-4 py-3 border-b border-dc-navy bg-gray-50"
  >
    <h3 class="font-semibold text-dc-navy">
      {{ "ACTIVITY_LIST.TITLE" | translate }}
    </h3>
    @if (selectedItems.length > 4) {
    <div class="w-60">
      <div class="flex items-center border border-gray-300 overflow-hidden">
        <input
          type="text"
          [placeholder]="'ACTIVITY_LIST.SEARCH_PH' | translate"
          class="flex-grow px-4 py-2 text-sm focus:outline-none"
          [(ngModel)]="searchQuery"
          (ngModelChange)="currentPage = 1"
        />
        <button type="button" class="px-4 text-dc-navy">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
    }
  </div>
  <!--  Activity rows (max 4 per page) -->
  @for (item of pagedItems; track item['code'] ?? $index) {
  <div
    class="flex justify-between items-start gap-4 px-4 py-3 border-b border-dc-navy! last:border-b-0"
    [ngClass]="item.endDate ? 'inactive-card' : ''"
  >
    <div class="max-w-full leading-snug">
      @if (item.code) {
      <p class="text-xs font-semibold text-dc-navy!">
        {{ item.code }}
      </p>
      }
      <p class="font-semibold text-dc-navy!">
        {{ item.name }}
      </p>
      @if (item.description || item?.descriptionOtherEn) {
      <p class="text-dc-navy! text-xs">
        {{
          item?.descriptionOtherEn ? item.descriptionOtherEn : item.description
        }}
        <br />
        {{ item?.descriptionOtherAr ? item.descriptionOtherAr : "" }}
      </p>
      } @if(item.endDate){
      {{ item.endDate | date }}
      } @if (otherActionText) {
      <a class="text-dc-navy! text-xs underline mt-4 inline-block">{{
        otherActionText
      }}</a>
      }
    </div>
    <div>
      <!-- item?.id -->
      @if (showAction && item?.id && item.code?.startsWith('Other')) {
      <button
        type="button"
        class="underline text-dc-navy text-sm shrink-0 p-5"
        (click)="openAddForm(item); $event.stopPropagation()"
      >
        {{ "BUTTONS.EDIT" | translate }}
      </button>
      } @if(showAction){ @if(!item?.endDate){
      <button
        (click)="removeItem(item)"
        class="text-gray-600 hover:text-red-600 text-lg font-bold leading-none"
        aria-label="Remove"
      >
        <i class="fas fa-close"></i>
      </button>
      } @else {
      <button
        (click)="activateItem(item)"
        class="text-dc-navy hover:text-green-600 text-lg font-bold leading-none"
        aria-label="Activate"
      >
        <i class="fas fa-undo"></i>
      </button>
      } }
    </div>
  </div>
  }
  <!-- Footer: total + pagination -->
  <div
    class="flex items-center justify-between px-4 py-2 border-t border-dc-navy"
  >
    <span class="text-xs text-dc-navy">
      {{ "ACTIVITY_LIST.TOTAL" | translate : { n: selectedItems.length } }}
    </span>
    <!-- pagination appears only if more than one page -->
    @if (totalPages > 1) {
    <nav aria-label="Pagination" class="flex items-center gap-2 text-xs">
      <!-- Prev arrow -->
      <button
        class="flex items-center gap-1 hover:underline disabled:text-gray-400"
        [disabled]="currentPage === 1"
        (click)="currentPage = currentPage - 1"
      >
        <i class="fas fa-angle-left transition-transform rtl:rotate-180"></i>
        {{ "PAGINATION.PREV" | translate }}
      </button>
      <!-- simple 1 2 … n numbers -->
      @for (p of [].constructor(totalPages); track p ?? $index; let i = $index)
      {
      <button
        class="w-6 h-6 text-center rounded-full"
        [ngClass]="{
          'bg-dc-navy text-white': currentPage === i + 1,
          'hover:bg-gray-200': currentPage !== i + 1
        }"
        (click)="currentPage = i + 1"
      >
        {{ i + 1 }}
      </button>
      }
      <!-- Next arrow -->
      <button
        class="flex items-center gap-1 hover:underline disabled:text-gray-400"
        [disabled]="currentPage === totalPages"
        (click)="currentPage = currentPage + 1"
      >
        {{ "PAGINATION.NEXT" | translate }}
        <i class="fas fa-angle-right transition-transform rtl:rotate-180"></i>
      </button>
    </nav>
    }
  </div>
</div>
}
